module.exports = __webpack_public_path__ + "img/logmms_512x512.88a39cad.png";